import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';

export const WhatIs: React.FC = () => {
  return (
    <Section className="border-b border-gray-200/60">
      <div className="flex flex-col md:flex-row gap-16 md:gap-24">
        {/* Left Column */}
        <div className="flex-1">
          <h2 className="text-4xl md:text-5xl font-serif mb-8 text-primary leading-tight">What is LeadFraud.org?</h2>
          <p className="text-secondary leading-relaxed text-lg md:text-xl font-light font-sans">
            LeadFraud.org is an independent standards initiative for B2B demand generation. We map how leads are actually created, define a clear bar for integrity, and publish shared standards the industry can rely on. 
            <br /><br />
            Think of it as the missing reference layer in a market that’s been running on vague language and self-reported numbers.
          </p>
        </div>

        {/* Right Column */}
        <div className="flex-1 flex flex-col justify-center gap-8 pt-4">
          {[
            "For buyers → practical lenses to see how leads are really sourced and where the risks sit.",
            "For honest vendors → a way to differentiate on integrity and evidence, not just claims.",
            "For operators → shared definitions and benchmarks for reality, not just dashboards."
          ].map((text, i) => (
            <div key={i} className="flex gap-5 items-start">
              <div className="mt-1.5 flex-shrink-0 w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center">
                <Check className="w-3 h-3 text-primary" />
              </div>
              <p className="text-primary font-sans font-normal text-lg leading-snug">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};